"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _RowWithShadow = require("../helpers/RowWithShadow");

var _responsive = require("../responsive");

var _utils = require("../utils");

var _constants = require("./constants");

var _context = require("./context");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["children", "isSticky"];
var modalFooterDefaultProps = {
  isSticky: true
};

var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? modalFooterDefaultProps.isSticky : _ref$isSticky,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useHighZoomLevel = (0, _responsive.useHighZoomLevel)(),
      isInHighZoomLevel = _useHighZoomLevel.isInHighZoomLevel;

  var _useModalContext = (0, _context.useModalContext)(),
      footerHasShadow = _useModalContext.footerHasShadow;

  return (0, _core.jsx)(_helperComponents.ModalFooterRow, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    backgroundColor: _constants.BACKGROUND_COLOR,
    hasShadow: isSticky && !isInHighZoomLevel ? footerHasShadow : false,
    shadowPosition: _RowWithShadow.ShadowPosition.Top,
    display: "flex",
    dataTestComponent: "StencilModalFooter",
    isFooter: true,
    padding: isInHighZoomLevel ? 'S200' : _constants.FOOTER_PADDING
  }), children);
};

var _default = (0, _utils.composeStencilComponent)({
  baseComponent: ModalFooter,
  description: 'Footer of the Modal.',
  displayName: 'ModalFooter',
  defaultProps: modalFooterDefaultProps,
  propTypes: {
    children: _stencilReactDesc.PropTypes.node.isRequired.description('Content to display in the modal footer.'),
    isSticky: _stencilReactDesc.PropTypes.bool.description('Configure the footer to be sticky while scrolling.')
  }
});

exports.default = _default;